import React, { useLayoutEffect, useRef, useState } from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import Collapse from "@mui/material/Collapse";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import CloseIcon from "@mui/icons-material/Close";
import EarbudsBatteryIcon from "@mui/icons-material/EarbudsBattery";
import ComputerIcon from "@mui/icons-material/Computer";
import EmailIcon from "@mui/icons-material/Email";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import { gsap } from "gsap";

function NavbarMobile({ handleMenu }) {
  const [openPhones, setOpenPhones] = useState(false);
  const [openMobileAcc, setOpenMobileAcc] = useState(false);
  const [openPcAcc, setOpenPcAcc] = useState(false);
  const [openService, setOpenService] = useState(false);
  const navRef = useRef(null);

  useLayoutEffect(() => {
    if (!navRef.current) {
      return undefined;
    }

    const ctx = gsap.context(() => {
      const timeline = gsap.timeline({
        defaults: { ease: "power3.out" },
      });

      timeline.fromTo(
        ".mobile__nav-overlay",
        { opacity: 0 },
        { opacity: 1, duration: 0.25 }
      );

      timeline.fromTo(
        ".mobile__nav-shell",
        {
          xPercent: 16,
          opacity: 0,
          rotateY: -10,
          rotateX: 4,
          transformPerspective: 1200,
        },
        {
          xPercent: 0,
          opacity: 1,
          rotateY: 0,
          rotateX: 0,
          duration: 0.6,
        },
        0
      );

      timeline.fromTo(
        ".mobile__nav-glow, .mobile__nav-grid",
        { opacity: 0, scale: 0.88 },
        {
          opacity: 1,
          scale: 1,
          duration: 0.7,
          stagger: 0.08,
        },
        0.08
      );

      timeline.fromTo(
        ".mobile__nav-header, .mobile__nav-item, .mobile__nav-footer a",
        { y: 26, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.48,
          stagger: 0.05,
        },
        0.12
      );

      gsap.to(".mobile__nav-glow--primary", {
        y: -20,
        x: 12,
        duration: 4.6,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
      });

      gsap.to(".mobile__nav-glow--secondary", {
        y: 18,
        x: -10,
        duration: 5.4,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
      });

      gsap.to(".mobile__nav-grid", {
        yPercent: -4,
        duration: 8,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
      });
    }, navRef);

    return () => ctx.revert();
  }, []);

  const togglePhones = () => {
    setOpenPhones(!openPhones);
    setOpenMobileAcc(false);
    setOpenPcAcc(false);
    setOpenService(false);
  };

  const toggleMobileAcc = () => {
    setOpenMobileAcc(!openMobileAcc);
    setOpenPhones(false);
    setOpenPcAcc(false);
    setOpenService(false);
  };

  const togglePcAcc = () => {
    setOpenPcAcc(!openPcAcc);
    setOpenPhones(false);
    setOpenMobileAcc(false);
    setOpenService(false);
  };

  const toggleService = () => {
    setOpenService(!openService);
    setOpenPhones(false);
    setOpenMobileAcc(false);
    setOpenPcAcc(false);
  };

  return (
    <aside className="mobile__nav mobile__nav--open" ref={navRef}>
      <div className="mobile__nav-overlay" onClick={handleMenu} />
      <div className="mobile__nav-shell">
        <div className="mobile__nav-scene" aria-hidden="true">
          <div className="mobile__nav-glow mobile__nav-glow--primary" />
          <div className="mobile__nav-glow mobile__nav-glow--secondary" />
          <div className="mobile__nav-grid" />
        </div>
        <div>
          <div className="mobile__nav-header">
            <span className="mobile__nav-eyebrow">Buzz Mobile</span>
            <button
              type="button"
              className="mobile__nav-close"
              aria-label="Затвори мени"
              onClick={handleMenu}
            >
              <CloseIcon fontSize="medium" />
            </button>
          </div>
        </div>

        <List
          className="mobile__nav-list"
          sx={{
            width: "100%",
            bgcolor: "transparent",
            color: "white",
          }}
          component="nav"
        >
          <ListItemButton className="mobile__nav-item" onClick={togglePhones}>
            <ListItemIcon>
              <PhoneIphoneIcon />
            </ListItemIcon>
            <ListItemText primary="Мобилни телефони" />
            {openPhones ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={openPhones} timeout="auto" unmountOnExit>
            <List component="div" disablePadding className="mobile__nav-sublist">
              <ListItemButton className="mobile__nav-subitem" component="a" href="/telefoni/Apple">
                <ListItemText primary="Apple" />
              </ListItemButton>
              <ListItemButton className="mobile__nav-subitem" component="a" href="/telefoni/Samsung">
                <ListItemText primary="Samsung" />
              </ListItemButton>
              <ListItemButton className="mobile__nav-subitem" component="a" href="/telefoni/Huawei">
                <ListItemText primary="Huawei" />
              </ListItemButton>
              <ListItemButton className="mobile__nav-subitem" component="a" href="/telefoni/Xiaomi">
                <ListItemText primary="Xiaomi" />
              </ListItemButton>
            </List>
          </Collapse>

          <ListItemButton className="mobile__nav-item" onClick={toggleMobileAcc}>
            <ListItemIcon>
              <EarbudsBatteryIcon />
            </ListItemIcon>
            <ListItemText primary="Мобилна галантерија" />
            {openMobileAcc ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={openMobileAcc} timeout="auto" unmountOnExit>
            <List component="div" disablePadding className="mobile__nav-sublist">
              <ListItemButton className="mobile__nav-subitem" component="a" href="/galanterija/polnaci">
                <ListItemText primary="Полначи" />
              </ListItemButton>
              <ListItemButton className="mobile__nav-subitem" component="a" href="/galanterija/wpolnac">
                <ListItemText primary="Wireless полначи" />
              </ListItemButton>
              <ListItemButton className="mobile__nav-subitem" component="a" href="/galanterija/adapteri">
                <ListItemText primary="Адаптери" />
              </ListItemButton>
              <ListItemButton className="mobile__nav-subitem" component="a" href="/galanterija/slusalki">
                <ListItemText primary="Слушалки" />
              </ListItemButton>
              <ListItemButton className="mobile__nav-subitem" component="a" href="/galanterija/kabli">
                <ListItemText primary="Кабли" />
              </ListItemButton>
              <ListItemButton className="mobile__nav-subitem" component="a" href="/galanterija/bzvucnici">
                <ListItemText primary="Bluetooth звучници" />
              </ListItemButton>
              <ListItemButton className="mobile__nav-subitem" component="a" href="/galanterija/dodatocizakola">
                <ListItemText primary="Додатоци за кола" />
              </ListItemButton>
            </List>
          </Collapse>

          <ListItemButton className="mobile__nav-item" onClick={togglePcAcc}>
            <ListItemIcon>
              <ComputerIcon />
            </ListItemIcon>
            <ListItemText primary="Компјутерска галантерија" />
            {openPcAcc ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={openPcAcc} timeout="auto" unmountOnExit>
            <List component="div" disablePadding className="mobile__nav-sublist">
              <ListItemButton className="mobile__nav-subitem" component="a" href="/galanterija/gslusalki">
                <ListItemText primary="Слушалки" />
              </ListItemButton>
              <ListItemButton className="mobile__nav-subitem" component="a" href="/galanterija/ggluvcinja">
                <ListItemText primary="Глувчиња" />
              </ListItemButton>
              <ListItemButton className="mobile__nav-subitem" component="a" href="/galanterija/gtastaturi">
                <ListItemText primary="Тастатури" />
              </ListItemButton>
              <ListItemButton className="mobile__nav-subitem" component="a" href="/galanterija/gpodlogi">
                <ListItemText primary="Подлоги за маус" />
              </ListItemButton>
              <ListItemButton className="mobile__nav-subitem" component="a" href="/galanterija/gzvucnici">
                <ListItemText primary="Звучници" />
              </ListItemButton>
            </List>
          </Collapse>

          <ListItemButton className="mobile__nav-item" onClick={toggleService}>
            <ListItemIcon>
              <MiscellaneousServicesIcon />
            </ListItemIcon>
            <ListItemText primary="Сервис" />
            {openService ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={openService} timeout="auto" unmountOnExit>
            <List component="div" disablePadding className="mobile__nav-sublist">
              <ListItemButton
                className="mobile__nav-subitem"
                component="a"
                href="/servis"
                onClick={handleMenu}
              >
                <ListItemText primary="Сервис цени" />
              </ListItemButton>
              <ListItemButton
                className="mobile__nav-subitem"
                component="a"
                href="/status"
                onClick={handleMenu}
              >
                <ListItemText primary="Статус" />
              </ListItemButton>
            </List>
          </Collapse>

          <ListItemButton className="mobile__nav-item" component="a" href="/kontakt">
            <ListItemIcon>
              <EmailIcon />
            </ListItemIcon>
            <ListItemText primary="Контакт" />
          </ListItemButton>

        </List>

        <div className="mobile__nav-footer">
          <a
            href="https://www.instagram.com/buzzmobile.mk"
            className="links"
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstagramIcon />
          </a>
          <a
            href="https://www.facebook.com/buzzmobilemk/"
            className="links"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FacebookIcon />
          </a>
        </div>
      </div>
    </aside>
  );
}

export default NavbarMobile;
